/**
 * Purpose: Error type thrown by {@link LlmClient}. Distinguishes
 *          server-side JSON-RPC failures (the server returned an `error`
 *          envelope) from transport-level failures (HTTP non-2xx,
 *          network error, malformed JSON).
 *
 * Implementation notes:
 *   - One class with a `kind` discriminator rather than two parallel
 *     classes — callers branch on `err.kind` if they care to. Mirrors
 *     the @ada/credits-client and @ada/api-keys-client shape.
 *
 * Created: 2026-05-06 23:30
 *
 * Changelog:
 *   - 2026-05-06 23:30 — Initial version.
 */
/**
 * Thrown by {@link LlmClient} on any non-success outcome.
 *
 * - `kind: 'rpc'` — server returned a JSON-RPC `error` envelope. `code`
 *   is the JSON-RPC error code (e.g. `-32601` for MethodNotFound, or an
 *   llm-specific code in `-32007..-32015`).
 * - `kind: 'transport'` — HTTP non-2xx, network error, or unparseable
 *   body. `httpStatus` is set when available; `cause` carries the
 *   underlying error.
 */
export class LlmClientError extends Error {
    kind;
    method;
    code;
    data;
    httpStatus;
    constructor(message, opts) {
        super(message, opts.cause !== undefined ? { cause: opts.cause } : undefined);
        this.name = 'LlmClientError';
        this.kind = opts.kind;
        this.method = opts.method;
        this.code = opts.code;
        this.data = opts.data;
        this.httpStatus = opts.httpStatus;
    }
}
//# sourceMappingURL=errors.js.map